import axios from 'axios'
import { useState, useEffect } from 'react';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from "react-select";
import { MdMessage } from "react-icons/md";
import { HiOutlineMail } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";

function ServiceReminder() {

    const [showForm, setShowForm] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [form, setForm] = useState({
        service_type: '',
        sms_text: '',
        email_text: '',
    })

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedService, setSelectedService] = useState(null);
    const [messageList, setMessageList] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [stateData, setStateData] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [regionOptions, setRegionOptions] = useState([]);
    const [pincodeOptions, setPincodeOptions] = useState([]);
    const [partyOptions, setPartyOptions] = useState([]);
    const [selectedParties, setSelectedParties] = useState([]);

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };




    const [sendOptions, setSendOptions] = useState({
        message: false,
        email: false,
        whatsapp: false
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
   
    const handleServiceChange = (option) => {
        setSelectedService(option);

        if (option) {
            setForm((prev) => ({
                ...prev,
                service_type: option.value,
                sms_text: option.sms_text || "",
                email_text: option.email_text || "",
            }));
        } else {

            setForm((prev) => ({
                ...prev,
                service_type: "",
                sms_text: "",
                email_text: "",
            }));
        }
    };


    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setSendOptions({ ...sendOptions, [name]: checked });
    };


    const fetchmessage = async () => {
  try {
    const res = await axios.get("https://api.skyguard.group/api/fetch-master-message");

    const options = res.data.map((msg) => ({
      value: msg.service_type,
      label: msg.service_type,
      sms_text: msg.sms_text,
      email_text: msg.email_text
    }));

    setMessageList(options);

   
    setSelectedService(null);

  } catch (error) {
    console.error("Error fetching service types:", error);
  }
};
    const fetchDataByState = async (state) => {
        if (!state) return;

        try {
            const response = await axios.get(
                `https://api.skyguard.group/api/get-state-data?state=${encodeURIComponent(state)}`
            );

            const data = response.data;

            if (!data || data.length === 0) {
                setStateData([]);
                setCityOptions([]);
                setPincodeOptions([]);
                showToast("No city available for this state", "warning");
                return;
            }

            setStateData(data);

            // unique cities
            const cityList = [...new Set(data.map(item => item.city))];

            const cityOptionsFormatted = cityList.map(city => ({
                value: city,
                label: city,
            }));

            const pincodeOptionsFormatted = data.map(item => ({
                value: item.pincode,
                label: item.pincode,
            }));


            setCityOptions(cityOptionsFormatted);
            setPincodeOptions(pincodeOptionsFormatted);

        } catch (error) {
            console.error("Error fetching cities by state:", error);
        }
    };

    const fetchStates = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/get-states");
            const options = res.data.map((state) => ({
                value: state,
                label: state,
            }));

            setStateOptions(options);

        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };


    const fetchCallDetailByRegion = async (region) => {
        if (!region) return;

        try {
            const res = await axios.get(
                `https://api.skyguard.group/api/fetch-message-reminder-region?region=${encodeURIComponent(region)}`
            );


            const options = res.data.map((party) => ({
                value: party.id,
                label: `${party.name} (${party.phone || "N/A"})`,
                email: party.email,
            }));

            setPartyOptions(options);
            setSelectedParties([]);
            showToast("Party Fetch Successfully!",'success');

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchmessage();
        fetchDataByState();
        fetchStates();
        fetchCallDetailByRegion();
    }, []);



    const handleStateChange = (state) => {
        setSelectedState(state);
        setSelectedCity(null);
        setSelectedRegion(null);
        setRegionOptions([]);

        if (state) {
            fetchDataByState(state.value);
        } else {
            setCityOptions([]);
            setStateData([]);
        }
    };


    const handleCityChange = (city) => {
        setSelectedCity(city);
        setSelectedRegion(null);

        if (!city) {
            setRegionOptions([]);
            return;
        }

        const regions = stateData
            .filter(item => item.city === city.value)
            .map(item => item.region);

        const uniqueRegions = [...new Set(regions)];
        const regionOptionsFormatted = uniqueRegions.map(region => ({
            value: region,
            label: region,
        }));
        setRegionOptions(regionOptionsFormatted);
    };



    const handleSave = async (e) => {
        e.preventDefault();

        if (!sendOptions.email && !sendOptions.whatsapp) {
            showToast("Please select at least one send option.", "warning");
            return;
        }


        if (!selectedParties || selectedParties.length === 0) {
            showToast("Please select at least one party", "warning");
            return;
        }

        try {
            const emails = selectedParties
                .map((party) => party.email)
                .filter(Boolean);


            const phoneNumbers = selectedParties
                .map((party) => party.phone)
                .filter(Boolean);

            if (sendOptions.email) {
                if (emails.length === 0) {
                    showToast("Selected parties do not have email addresses.", "warning");
                    return;
                }

                await axios.post(
                    "https://api.skyguard.group/api/send-service-remeinder",
                    {
                        email: emails,
                        service_type: form.service_type,
                        email_text: form.email_text,
                    }
                );
            }


            if (sendOptions.whatsapp) {
                if (phoneNumbers.length === 0) {
                    showToast("Selected parties do not have phone numbers.", "warning");
                    return;
                }

                console.log('Whatsapp api call successfully')
            }


            showToast("Message sent successfully!", "success");
            setForm({
                service_type: "",
                sms_text: "",
                email_text: "",
            });

            setSelectedService(null);
            setSelectedState(null);
            setSelectedCity(null);
            setSelectedRegion(null);
            setSelectedParties([]);

            setCityOptions([]);
            setRegionOptions([]);
            setPartyOptions([]);

            setSendOptions({
                message: false,
                email: false,
                whatsapp: false,
            });

        } catch (error) {
            console.error(error);
            showToast("Failed to send message!", "danger");
        }
    };


const resetFrom = () => {
     setForm({
                service_type: "",
                sms_text: "",
                email_text: "",
            });

            setSelectedService(null);
            setSelectedState(null);
            setSelectedCity(null);
            setSelectedRegion(null);
            setSelectedParties([]);

            setCityOptions([]);
            setRegionOptions([]);
            setPartyOptions([]);

            setSendOptions({
                message: false,
                email: false,
                whatsapp: false,
            }); 
}

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />

                <h3 className='my-3 fw-bold fs-5 golos'>Service Reminder</h3>

                <div className='card p-3 mb-3  w-75 mx-auto'>
                    <form  >
                        <hr />

                        <div className='row g-3'>

                            <div className="col-md-6">
                                <label htmlFor="service_type" className="form-label fw-medium">
                                    Service Type
                                </label>

                                <Select
                                    options={messageList}
                                    value={selectedService}
                                    onChange={handleServiceChange}
                                    placeholder="Select Service Type"
                                    isClearable
                                    isDisabled={messageList.length === 0}
                                />
                            </div>


                            <div className="col-12 col-md-6  mb-2">
                                <label className="form-label fw-medium">State</label>
                                <Select
                                    options={stateOptions}
                                    value={selectedState}
                                    onChange={handleStateChange}
                                    placeholder="Select State"
                                    isClearable
                                />
                            </div>

                            <div className="col-12 col-md-6  mb-2">
                                <label className="form-label fw-medium">City</label>
                                <Select
                                    options={cityOptions}
                                    value={selectedCity}

                                    onChange={handleCityChange}
                                    placeholder="Select City"
                                    isClearable
                                    isDisabled={!selectedState}
                                />
                            </div>

                            <div className="col-12 col-md-6 mb-2">
                                <label className="form-label fw-medium">Region</label>
                                <Select
                                    options={regionOptions}
                                    value={selectedRegion}
                                    placeholder="Select Region"
                                    onChange={(option) => setSelectedRegion(option)}
                                    isClearable
                                    isDisabled={!selectedCity}
                                />
                            </div>


                            <div className="col-md-12 text-end">
                                <button type='button' className='btn btn-primary' onClick={() => fetchCallDetailByRegion(selectedRegion?.value)}>Search </button>
                            </div>

                            <div className="col-md-6 ">
                                <label className="form-label fw-medium">Select Party</label>
                                <Select
                                    options={partyOptions}
                                    value={selectedParties}
                                    onChange={(options) => setSelectedParties(options)}
                                    isMulti
                                    placeholder="Select Parties..."
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="col-md-6 mb-2">
                                <label className="form-label fw-medium d-block mb-2">Send Message</label>

                                <div className="d-flex gap-3">
                                    {/* Message */}
                                    {/* <div className="form-check d-flex align-items-center gap-2">
      <input
        className="form-check-input"
        type="checkbox"
        name="message"
        id="messageCheck"
        checked={sendOptions.message}
        onChange={handleCheckboxChange}
      />
      <label className="form-check-label d-flex align-items-center" htmlFor="messageCheck">
        <MdMessage size={20} className="me-1 mt-2 text-warning" /> Message
      </label>
    </div> */}

                                    {/* Email */}
                                    <div className="form-check d-flex align-items-center gap-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="email"
                                            id="emailCheck"
                                            checked={sendOptions.email}
                                            onChange={handleCheckboxChange}
                                        />
                                        <label className="form-check-label d-flex align-items-center" htmlFor="emailCheck">
                                            <HiOutlineMail size={20} className="me-1 mt-2 text-danger" /> Email
                                        </label>
                                    </div>

                                    {/* WhatsApp */}
                                    <div className="form-check d-flex align-items-center gap-2">
                                        {/* <input
        className="form-check-input"
        type="checkbox"
        name="whatsapp"
        id="whatsappCheck"
        checked={sendOptions.whatsapp}
        onChange={handleCheckboxChange}
      /> */}
                                        <label className="form-check-label d-flex align-items-center" htmlFor="whatsappCheck">
                                            <FaWhatsapp size={20} className="me-1 text-success mt-2" /> WhatsApp
                                        </label>
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6">
                                <label htmlFor='middle' className="form-label fw-medium" >SMS Text </label>
                                <textarea
                                    type='text'
                                    name='sms_text'
                                    value={form.sms_text}
                                    className='form-control'
                                    rows={6}
                                    onChange={handleInputChange} required
                                />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor='middle' className="form-label fw-medium" >Email Text </label>
                                <textarea
                                    type='text'
                                    name='email_text'
                                    value={form.email_text}
                                    className='form-control'
                                    rows={6}
                                    onChange={handleInputChange} required
                                />
                            </div>

                            <div className='gap-2 d-flex justify-content-center mt-4'>
                                <button type="submit" className='btn btn-success w-10' onClick={handleSave}>
                                    Save
                                </button>
                                <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                    setShowForm(false);
                                    setIsEditMode(false);
                                    
                                    resetFrom();
                                }}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ServiceReminder